import React, { FunctionComponent } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { ApplicantListContainer } from '../../containers';

const ApplicantsPage: FunctionComponent<Props> = () => (
    <ApplicantListContainer />
);

export default withRouter(ApplicantsPage);

type Props = RouteComponentProps;
